import htmx from 'htmx.org';

// The ESM build does not attach itself to window; tt-results.js and inline handlers use
// the global htmx API.
window.htmx = htmx;
